import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerCloudServer from "../../images/banners/banner_cloud_server.png";

const CloudServerPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Cloud Server Somar
                      </span>
                      <h2 className="title">
                        Performance Empresarial, <br /> Sem Compromissos <br />{" "}
                        para aplicações de missão crítica
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerCloudServer} alt="Cloud Server Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Cloud Server Somar: Performance Empresarial, Sem Compromissos
                </h2>
                <p className="sd-content">
                  O Cloud Server da Somar Cloud é a solução ideal para
                  aplicações empresariais de missão crítica que exigem alta
                  performance, segurança avançada e alta disponibilidade. Com
                  infraestrutura de última geração no Brasil, entregamos poder
                  computacional real para bancos de dados robustos, sistemas
                  ERP, e aplicações que não podem parar.
                </p>
                <br />
                <p className="sd-content">
                  Processamento Intel Xeon, storage all-flash com acesso
                  redundante (multipath) e rede dedicada de 10Gbps garantem
                  performance estável e disponibilidade ininterrupta para suas
                  aplicações. Nossa arquitetura escalável permite expansão
                  vertical e horizontal sob demanda, enquanto SLA de 99,95%
                  garante operação contínua com proteção total.
                </p>
                <br />
                <p className="sd-content">
                  <strong>
                    Infraestrutura Premium para Ambientes Críticos:
                  </strong>{" "}
                  O Cloud Server Somar é projetado para operações que não podem
                  parar. Com redundância total, failover automático e alta
                  disponibilidade nativa, sua aplicação roda com desempenho
                  máximo — sempre. Infraestrutura 100% nacional garante menor
                  latência, dados no Brasil e conformidade total com a LGPD.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">
                  Implementação Ágil e Assistida por Especialistas
                </h2>
                <p className="sd-content">
                  Nossa equipe realiza toda a implantação com segurança,
                  planejamento e acompanhamento próximo. Garantimos uma
                  transição suave e eficiente, sem comprometer seu ambiente
                  atual.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Assessment Técnico</h3>
                  <p className="xb-item--contact">
                    Análise detalhada das suas cargas e necessidades de
                    performance.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Arquitetura Sob Medida</h3>
                  <p className="xb-item--contact">
                    Ambiente desenhado especificamente para suas aplicações.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Deploy Seguro</h3>
                  <p className="xb-item--contact">
                    Provisionamento e testes rigorosos antes da entrega final.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Acompanhamento Contínuo</h3>
                  <p className="xb-item--contact">
                    Monitoramento ativo e ajustes automáticos para máxima
                    eficiência.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">
                    Recursos e Benefícios do Cloud Server Somar
                  </h2>
                  <p className="sd-content">
                    Infraestrutura premium projetada para operações que não
                    podem parar. Poder computacional, estabilidade e suporte
                    dedicado com a flexibilidade da nuvem.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Desempenho extremo - Intel Xeon e storage all-flash
                      multipath
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Segurança de ponta - Firewall dedicado e proteção DDoS
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Escalabilidade real - CPU, memória e disco sob demanda
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Backups automáticos - Proteção contínua com RPO zero
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Monitoramento inteligente - Análise preditiva com IA
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Infraestrutura 100% nacional - Menor latência e LGPD
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      SLA 99,95% - Operação contínua garantida
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Suporte especializado 24/7 - Equipe técnica em português
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default CloudServerPage;
